module.exports = __webpack_public_path__ + "static/assets/e5b71c7ad17c883827e66eb4a6ac30d4.png";